import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractService } from '../commons/abstract.service';
import { WebhookAudit } from '../models/webhook-audit.model';

/**
 * SPEC-2026-08-webhook-dedicated-database, RF-24 / RF-25 — read-only client for
 * the webhook audit records.
 *
 * INTERNAL ADMIN ONLY. These records hold verbatim provider credentials and
 * end-consumer personal data (RNF-03), and the backend gates every read on the
 * internal-administrator privilege plus a mandatory company. This service must
 * never be consumed from `trendmulti-web-app`.
 *
 * Uses only the inherited `super.getAll` / `super.get`, never `this.http`
 * directly — `.claude/rules/06-web-patterns.md`.
 */
@Injectable({ providedIn: 'root' })
export class WebhookAuditService extends AbstractService<WebhookAudit> {

  getURLBase(): string {
    return '/webhook-audit';
  }

  constructor(private http: HttpClient) {
    super(http);
  }

  // The collection has no write surface; these exist only to satisfy the base class.
  preCreate(obj: WebhookAudit): void { }
  preUpdate(obj: WebhookAudit): void { }

  /**
   * `company` is mandatory and is the caller's responsibility — the backend
   * refuses a read that does not name one (RF-23), and the screen never issues a
   * request before a company is selected.
   */
  findById(id: string, idCompany: string): Observable<WebhookAudit> {
    return super.get(`/${id}?company=${idCompany}`);
  }
}
